import { useEffect, useRef } from "react";
import {
  CANAL_PANTALLA_CLIENTE,
  INTERVALO_PULSO_MS,
  construirMensaje,
  soportaPantallaCliente,
} from "../pantallaCliente/canal";

// Publica el estado completo del POS hacia la pantalla al cliente: un pulso por
// segundo más una emisión inmediata cuando cambia algo que ve el comprador.
// No hay saludo ni diferencias: la pestaña reabierta se llena en el pulso
// siguiente y, si esta pestaña muere, los pulsos se cortan y el standby entra
// solo por ausencia.
export default function usePublicadorPantallaCliente(snapshot) {
  const canalRef = useRef(null);
  // La firma no lleva `ts`: cambia sólo cuando cambia el contenido, que es lo
  // que dispara la emisión inmediata y reinicia el pulso.
  const cuerpo = construirMensaje(snapshot, 0);
  const firma = JSON.stringify(cuerpo);
  const cuerpoRef = useRef(cuerpo);
  cuerpoRef.current = cuerpo;

  useEffect(() => {
    if (!soportaPantallaCliente) return undefined;
    const canal = new BroadcastChannel(CANAL_PANTALLA_CLIENTE);
    canalRef.current = canal;
    return () => {
      canalRef.current = null;
      canal.close();
    };
  }, []);

  useEffect(() => {
    if (!soportaPantallaCliente) return undefined;
    const publicar = () => {
      canalRef.current?.postMessage({ ...cuerpoRef.current, ts: Date.now() });
    };
    publicar();
    const pulso = setInterval(publicar, INTERVALO_PULSO_MS);
    return () => clearInterval(pulso);
  }, [firma]);
}
